@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.drivergroups

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.drivergroups.DriverGroupDto

object UpsertDriverGroupEndpoint :
    EndPoint<UpsertDriverGroupEndpoint.Request, UpsertDriverGroupEndpoint.Response>() {
    class Request(
        val driverGroup: DriverGroupDto
    )

    class Response(
    )
}